import instance from '@apis/instance';

class TestUserApi {
    static isTestUser(): Promise<never> {
        return instance.head('/v0/test-user');
    }
}

export default TestUserApi;
